module.exports = __webpack_public_path__ + "static/media/icon_event_default.02a308ca.svg";